import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideApi } from '../generated';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { provideMarkdown } from 'ngx-markdown';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(),
    provideApi({
      basePath: environment.authApiBaseUrl,
      withCredentials: true,
    }),
    provideMarkdown(),
  
  ],
};
